// "Build from Documents" batch-upload card (s98). The card is a PERMANENT dashboard
// tool, not onboarding (s98 design revision): it shows regardless of plan progress and
// is never permanently dismissed. The only dismiss is the session-level "Not right now"
// (resets on reload). See docs/archive/cc-prompts/build-from-documents.md.

/**
 * The card shows unless it was dismissed THIS session. No essentials-count threshold and
 * no permanent dismiss — it's an always-available "upload documents" entry point.
 */
export function shouldShowBuildFromDocumentsCard(sessionDismissed: boolean): boolean {
  return !sessionDismissed;
}
